import { t } from 'i18next';
import { timeHelper } from 'src/app/helpers';
import { StudentReport } from 'src/app/redux/students/student-slice.type';
import { StudentDataType } from 'src/app/services/student/student.service.type';
import { StudentReportColumnType, StudentsColumnDataType } from 'src/types/table.type';

export const convertStudentListToTableData = (studentList: StudentDataType[]): StudentsColumnDataType[] => {
  const result: StudentsColumnDataType[] = [];

  studentList.forEach((student) => {
    result.push({
      id: student.id,
      studentName: student.studentName,
      qId: student.qId,
      rank: student.rank ? t(`studentsPage.ranks.${student.rank}`) : '',
      branch: student.branch,
      militaryId: student.militaryId || '',
      universityName: student.universityName,
      degreeType: student.degreeType,
      program: student.program,
      yearOfProgram: student.yearOfProgram,
      startYear: student.startYear,
      expectedGraduationYear: student.expectedGraduationYear,
      graduationYear: student.graduationYear,
      graduationApproved: student.graduationApproved === true ? 'Approved' : 'Not Yet',
    });
  });

  return result;
};
export type StudentDataIndex = keyof StudentsColumnDataType;

export const convertStudentReportDataToTableData = (studentReportList: StudentReport[]) => {
  const result: StudentReportColumnType[] = [];

  studentReportList.forEach((report) => {
    result.push({
      id: report.id,
      hasReport: report.hasReport,
      lastCreatedDate: report.lastCreatedDate ? timeHelper.formatDate(report.lastCreatedDate) : '',
      name: report.name,
      period: report.period,
    });
  });
  return result;
};
